module.exports = __webpack_public_path__ + "static/img/n1_10.bb834f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/n1_10.jpg
// module id = Lf8z
// module chunks = 2